import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // ✅ ADDED
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container); 

root.render(
  <BrowserRouter basename="/"> {/* ✅ ADDED */}
    <App />
  </BrowserRouter>
);
